/** Online-first (ADR-010): writes are disabled and a banner is shown while offline. */
class Online {
  value = $state(typeof navigator === 'undefined' ? true : navigator.onLine);

  constructor() {
    if (typeof window === 'undefined') return;
    window.addEventListener('online', () => (this.value = navigator.onLine));
    window.addEventListener('offline', () => (this.value = navigator.onLine));
  }
}

export const online = new Online();
